// 使用 Element UI 的消息提示工具
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/message.css'

export default {
  success(msg, duration = 3000) {
    Message.success({
      message: msg,
      duration: duration
    })
  },
  error(msg, duration = 3000) {
    Message.error({
      message: msg,
      duration: duration
    })
  },
  warning(msg, duration = 3000) {
    Message.warning({
      message: msg,
      duration: duration
    })
  },
  info(msg, duration = 3000) {
    Message.info({
      message: msg,
      duration: duration
    })
  },
  showMessage(msg, type = 'info', duration = 3000) {
    Message({
      message: msg,
      type: type,
      duration: duration
    })
  }
}

